// Mock data for MAC Law Advocates website

export const firmInfo = {
  name: "MAC Law Advocates",
  tagline: "Your Trusted Legal Partner in Nairobi",
  phone: "+254 726 404 984",
  email: "info@maclawadvocates.co.ke",
  address: "Legal Aid Center, Lenana Road, Nairobi, Kenya",
  rating: 5.0,
  reviewCount: 1,
  googleMapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.819267896785!2d36.8219!3d-1.2921!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMcKwMTcnMzEuNiJTIDM2wrA0OScxOC44IkU!5e0!3m2!1sen!2ske!4v1234567890"
};

export const practiceAreas = [
  {
    id: 1,
    title: "Corporate Law",
    description: "Comprehensive legal solutions for businesses, including company formation, contracts, mergers, and corporate governance.",
    icon: "Briefcase"
  },
  {
    id: 2,
    title: "Family Law",
    description: "Compassionate representation in divorce, child custody, adoption, and matrimonial property matters.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Real Estate Law",
    description: "Expert guidance on property transactions, land disputes, conveyancing, and property development.",
    icon: "Home"
  },
  {
    id: 4,
    title: "Criminal Defense",
    description: "Vigorous defense representation for criminal charges with a commitment to protecting your rights.",
    icon: "Shield"
  },
  {
    id: 5,
    title: "Civil Litigation",
    description: "Strategic litigation services for contract disputes, personal injury, and civil claims.",
    icon: "Scale"
  },
  {
    id: 6,
    title: "Employment Law",
    description: "Protecting rights and interests in workplace disputes, wrongful termination, and employment contracts.",
    icon: "FileText"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Client-Focused Approach",
    description: "We prioritize your needs and work tirelessly to achieve the best possible outcomes for your legal matters."
  },
  {
    id: 2,
    title: "Proven Track Record",
    description: "With a 5.0 rating and satisfied clients, our results speak for themselves."
  },
  {
    id: 3,
    title: "Professional Excellence",
    description: "Our advocates combine deep legal expertise with ethical practice and integrity."
  },
  {
    id: 4,
    title: "Personalized Solutions",
    description: "Every case is unique. We tailor our legal strategies to your specific situation."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Client Review",
    rating: 5,
    text: "Excellent legal services. Professional, responsive, and achieved great results for my case.",
    date: "2024"
  }
];
